var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'moral-list',
  created () {
    utils.moralBackClear()
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    morals () {
      return this.$store.getters.moralList
    },
    nextPage () {
      return this.$store.getters.moralListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.moralListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {}
      this.$store.dispatch('MORAL_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goMoralNew: function () {
      this.$router.push({ path: '/morals/new' })
    },
    goMoralDetail: function(moralId) {
      this.$router.push({ path: '/morals/' + moralId })
    },
    goMoralEdit: function(moralId) {
      this.$router.push({ path: '/morals/' + moralId + '/edit'})
    },
    moralDelete: function(moralId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('MORAL_DELETE', {id: moralId, callback: this.onSaved})
      }
    },
    onSaved: function (result) {
      this.$router.push('/moral_list')
    },
    status: function (start, end) {
      var today = new Date()
      var todayHyphen = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2)
      if (todayHyphen < start) {
        return '未公開'
      } else if (todayHyphen <= end){
        return '公開中'
      } else {
        return '公開完了'
      }
    },
    getColor: function (start, end) {
      var today = new Date()
      var todayHyphen = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2)
      if (todayHyphen < start) {
        return 'color-blue'
      } else if (todayHyphen <= end){
        return 'color-orange'
      } else {
        return 'color-gray'
      }
    },
    updateAvailable: function (start) {
      var today = new Date()
      var todayHyphen = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2)
      if (todayHyphen < start) {
        return false
      } else {
        return true
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-list.js